export enum DamageLevelEnum{
    PARTIALLY_DAMAGE='PARTIALLY DAMAGE',
    FULLY_DAMAGE='FULLY DAMAGE'
}